import { render, staticRenderFns } from "./customSettings.vue?vue&type=template&id=c0d8adc0&scoped=true&"
import script from "./customSettings.vue?vue&type=script&lang=js&"
export * from "./customSettings.vue?vue&type=script&lang=js&"
import style0 from "./customSettings.vue?vue&type=style&index=0&id=c0d8adc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d8adc0",
  null
  
)

export default component.exports